import { ShoppingBag } from "lucide-react";
import { useCart } from "@/state/CartContext";

export default function CartButton({ className = "" }) {
  const { count, setOpen } = useCart();
  return (
    <button
      onClick={() => setOpen(true)}
      className={`relative vintage-link text-xs sm:text-sm uppercase flex items-center gap-2 ${className}`}
      data-testid="cart-open"
      aria-label={`Open cart (${count} items)`}
    >
      <ShoppingBag className="w-4 h-4" strokeWidth={1.2} />
      <span className="hidden sm:inline">Cart</span>
      {count > 0 && (
        <span
          className="ml-1 inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5 vintage-text bg-white text-black text-xs leading-none tabular-nums"
          data-testid="cart-count"
        >
          {count}
        </span>
      )}
    </button>
  );
}
